<template>
  <!-- 业绩配比顶部 -->
  <div>
    <div class="top">
      <div class="f-search-block">
        <div class="search-items">
          <div class="field-item">
            <span>默认规则 </span>
          </div>
        </div>
        <div class="search-btns">
          <el-button
            type="primary"
            @click="handleSaveDefaultSetting"
          >
            保存设置
          </el-button>
        </div>
      </div>

      <!-- 默认规则表格 -->
      <el-container>
        <el-header>
          <el-row class="bb">
            <el-col :span="2">
              <div class="grid-content">
                订单归属
              </div>
            </el-col>
            <el-col :span="3">
              <div class="grid-content">
                销售导购
              </div>
            </el-col>
            <el-col :span="7">
              <div class="grid-content">
                绑定导购
              </div>
            </el-col>
            <el-col
              :span="7"
            >
              <div class="grid-content">
                业绩名称定义
                <el-tooltip
                  class="item"
                  effect="light"
                  placement="top"
                >
                  <div slot="content">
                    <el-image
                      style="height: 600px"
                      :src="require('@/assets/img/WechatIMG865.png')"
                    />
                  </div>
                  <i class="el-icon-question" />
                </el-tooltip>
              </div>
            </el-col>
            <el-col :span="5">
              <div class="grid-content">
                订单归属规则
              </div>
            </el-col>
          </el-row>
        </el-header>
        <el-main>
          <el-row>
            <el-col :span="2">
              <div class="grid-content">
                员工
              </div>
            </el-col>
            <el-col :span="3">
              <div class="grid-content bb">
                100%
              </div>
            </el-col>
            <el-col :span="7">
              <div class="grid-content bb" />
            </el-col>
            <el-col
              :span="7"
            >
              <div class="grid-content bb">
                <el-input
                  v-model="proportion.bind_sales.title"
                  class="w45"
                  placeholder="请输入内容"
                />
              </div>
            </el-col>
            <el-col
              :span="5"
            >
              <div class="grid-content bb">
                销售导购为<span class="red">员工</span>，无绑定导购
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="2">
              <div class="grid-content" />
            </el-col>
            <el-col
              :span="3"
            >
              <div class="grid-content bb">
                <el-input
                  v-model="proportion.sales.value"
                  placeholder="业绩比例"
                  class="w90"
                  max="100"
                >
                  <template slot="append">
                    %
                  </template>
                </el-input>
              </div>
            </el-col>
            <el-col
              :span="7"
            >
              <div class="grid-content bb">
                <el-input
                  v-model="proportion.bind.value"
                  placeholder="业绩比例"
                  class="w45"
                  max="100"
                >
                  <template slot="append">
                    %
                  </template>
                </el-input>
              </div>
            </el-col>
            <el-col
              :span="7"
            >
              <div class="grid-content bb">
                <el-input
                  v-model="proportion.sales.title"
                  class="w45 mr10"
                  placeholder="请输入内容"
                /><el-input
                  v-model="proportion.bind.title"
                  class="w45"
                  placeholder="请输入内容"
                />
              </div>
            </el-col>
            <el-col
              :span="5"
            >
              <div class="grid-content bb">
                销售导购为<span class="red">员工</span>，绑定导购为<span class="red">员工</span>
              </div>
            </el-col>
          </el-row><el-row>
            <el-col :span="2">
              <div class="grid-content bb" />
            </el-col>
            <el-col :span="3">
              <div class="grid-content bb" />
            </el-col>
            <el-col
              :span="7"
            >
              <div class="grid-content bb">
                <el-input
                  v-model="proportion.bind_operate.value"
                  placeholder="业绩比例"
                  class="w45 mr10"
                  max="100"
                >
                  <template slot="append">
                    %
                  </template>
                </el-input>
                <el-link
                  type="primary"
                  @click="exclusionVisible = true"
                >
                  {{ buttonText }}
                </el-link>
                &nbsp;
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="当前业绩计算排除指定门店下编外成员产生的订单"
                  placement="top"
                >
                  <i class="el-icon-question" />
                </el-tooltip>
              </div>
            </el-col>
            <el-col
              :span="7"
            >
              <div class="grid-content bb">
                <el-input
                  v-model="proportion.bind_operate.title"
                  class="w45"
                  placeholder="请输入内容"
                />
              </div>
            </el-col>
            <el-col
              :span="5"
            >
              <div class="grid-content bb">
                销售导购为<span class="red">编外</span>，绑定导购为<span class="red">员工</span>
              </div>
            </el-col>
          </el-row><el-row>
            <el-col :span="2">
              <div class="grid-content">
                编外
              </div>
            </el-col>
            <el-col :span="3">
              <div class="grid-content bb">
                100%
              </div>
            </el-col>
            <el-col :span="7">
              <div class="grid-content bb" />
            </el-col>
            <el-col
              :span="7"
            >
              <div class="grid-content bb">
                <el-input
                  v-model="proportion.operate_sales.title"
                  class="w45"
                  placeholder="请输入内容"
                />
              </div>
            </el-col>
            <el-col
              :span="5"
            >
              <div class="grid-content bb">
                销售导购为<span class="red">编外</span>，无绑定导购
              </div>
            </el-col>
          </el-row>
          <el-row class="bb">
            <el-col :span="2">
              <div class="grid-content" />
            </el-col>
            <el-col
              :span="3"
            >
              <div class="grid-content">
                <el-input
                  v-model="proportion.operate_bind.value"
                  placeholder="业绩比例"
                  class="w90"
                  max="100"
                >
                  <template slot="append">
                    %
                  </template>
                </el-input>
              </div>
            </el-col>
            <el-col :span="7">
              <div class="grid-content" />
            </el-col>
            <el-col
              :span="7"
            >
              <div class="grid-content">
                <el-input
                  v-model="proportion.operate_bind.title"
                  class="w45"
                  placeholder="请输入内容"
                />
              </div>
            </el-col>
            <el-col
              :span="5"
            >
              <div class="grid-content">
                销售导购为<span class="red">编外</span>，绑定导购为<span class="red">员工</span>
              </div>
            </el-col>
          </el-row>
        </el-main>
      </el-container>
    </div>

    <!-- 自定义规则 -->
    <div class="f-search-block">
      <div class="search-items">
        <div class="field-item">
          <span>自定义规则 </span>
        </div>
      </div>
      <div class="search-btns">
        <el-button @click="handleEdit({})">
          添加规则
        </el-button>
      </div>
    </div>

    <!-- 自定义规则表格 -->

    <div class="f-table-block">
      <el-table
        v-loading="loading"
        :data="list"
      >
        <el-table-column
          prop="name"
          label="规则名称"
          min-width="150"
        />
        <el-table-column
          prop="statusSwitch"
          label="状态"
          min-width="90"
        >
          <template slot-scope="scope">
            <el-tag :type="scope.row.statusSwitch">
              {{ scope.row.statusSwitchText }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="有效时间"
          min-width="270"
        >
          <template slot-scope="scope">
            <span
              v-if="scope.row.start_time"
            >{{ scope.row.start_time }} ~ {{ scope.row.end_time }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="created_at"
          label="添加时间"
          min-width="150"
        />
        <el-table-column
          label="操作"
          width="200"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="handleDetail(scope.row)"
            >
              查看规则
            </el-button>
            <el-button
              type="text"
              size="small"
              @click="handleEdit(scope.row)"
            >
              编辑
            </el-button>
            <el-button
              type="text"
              size="small"
              @click="handleDelete(scope.row)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 业绩排他 -->
    <Exclusion
      :exclusion-visible="exclusionVisible"
      :exclude-operate-store="excludeOperateStore"
      @exclusionVisibleChange="exclusionVisibleChange"
    />

    <!-- 查看规则 -->
    <el-dialog
      title="查看规则"
      :visible.sync="detailVisible"
      width="70%"
    >
      <DetailForm :proportion-props="proportionProps" />
    </el-dialog>

    <!-- 添加 && 编辑规则 -->
    <!-- <EditForm
      :proportionProps="proportionProps"
      :editVisible="editVisible"
      @editVisibleChange="editVisibleChange"
    /> -->
  </div>
</template>

<script>
import {
  getDefaultSetting,
  saveDefaultSettingList,
  getOtherSettingList,
  getOtherSettingDetail,
  deleteOtherSetting
} from '@/api/performance/distribution'
import DetailForm from '@/components/performanceDistribution/detailForm'
// import EditForm from '@/components/performanceDistribution/editForm'
import Exclusion from '@/components/performanceDistribution/exclusion'
import { getStoreList } from '@/api/component'

export default {
  name: 'PerformanceDistribution',
  components: {
    DetailForm,
    // EditForm,
    Exclusion
  },
  data () {
    return {
      proportion: {
        bind_sales: {
          title: '导购独立业绩',
          key: 3,
          key_str: 'bind_sales',
          value: '100',
          is_disable: true
        },
        sales: {
          title: '导购独立销售业绩',
          key: 1,
          key_str: '',
          value: '',
          is_disable: false
        },
        bind: {
          title: '独立绑定业绩',
          key: 2,
          key_str: '',
          value: '',
          is_disable: false
        },
        bind_operate: {
          title: '编外组合绑定业绩',
          key: 4,
          key_str: '',
          value: '',
          is_disable: false
        },
        operate_sales: {
          title: '运营专属销售业绩',
          key: 5,
          key_str: 'operate_sales',
          value: '100',
          is_disable: true
        },
        operate_bind: {
          title: '运营绑定销售业绩',
          key: 6,
          key_str: '',
          value: '',
          is_disable: false
        }
      },
      defaultProportion: {
        bind_sales: {
          title: '导购独立业绩',
          key: 3,
          key_str: 'bind_sales',
          value: '100',
          is_disable: true
        },
        sales: {
          title: '导购独立销售业绩',
          key: 1,
          key_str: '',
          value: '',
          is_disable: false
        },
        bind: {
          title: '独立绑定业绩',
          key: 2,
          key_str: '',
          value: '',
          is_disable: false
        },
        bind_operate: {
          title: '编外组合绑定业绩',
          key: 4,
          key_str: '',
          value: '',
          is_disable: false
        },
        operate_sales: {
          title: '运营专属销售业绩',
          key: 5,
          key_str: 'operate_sales',
          value: '100',
          is_disable: true
        },
        operate_bind: {
          title: '运营绑定销售业绩',
          key: 6,
          key_str: '',
          value: '',
          is_disable: false
        }
      },
      params: {},
      list: [],
      loading: false,
      direction: 'rtl',
      detailVisible: false,
      editVisible: false,
      exclusionVisible: false,
      proportionProps: {},
      excludeOperateStore: []
    }
  },
  computed: {
    valueLeft () {
      return this.proportion.sales.value
    },
    valueRight () {
      return this.proportion.bind.value
    },
    buttonText () {
      if (this.excludeOperateStore.length !== 0) {
        return '已设置排他'
      } else {
        return '业绩排他'
      }
    }
  },
  watch: {
    // valueLeft(value) {
    //   this.proportion.bind.value = String(100 - Number(value) > 0 ? (100 - Number(value)).toFixed(2) : 0)
    // },
    // valueRight(value) {
    //   this.proportion.sales.value = String(100 - Number(value) > 0 ? (100 - Number(value)).toFixed(2) : 0)
    // }
  },
  mounted () {
    this.getData()
  },
  methods: {
    // 获取默认规则数据
    async getData () {
      this.loading = true
      const data = await getDefaultSetting(this.params).catch(() => {
        this.loading = false
      })
      this.proportion = data.proportion
      if (data.exclude_operate_store.split(',')[0] === '') {
        this.excludeOperateStore = []
      } else {
        this.excludeOperateStore = data.exclude_operate_store.split(',')
      }
      const data2 = await getOtherSettingList(this.params).catch(() => {
        this.loading = false
        this.list = [{}]
      })
      // this.list = [
      //   {
      //     id: 3,
      //     name: 'test',
      //     stauts: 1,
      //     proportion: {
      //       bind_sales: {
      //         title: '导购独立业绩',
      //         key: 3,
      //         key_str: 'bind_sales',
      //         value: '100',
      //         is_disable: true
      //       },
      //       sales: {
      //         title: '导购独立销售业绩',
      //         key: 1,
      //         key_str: '',
      //         value: '',
      //         is_disable: false
      //       },
      //       bind: {
      //         title: '独立绑定业绩',
      //         key: 2,
      //         key_str: '',
      //         value: '',
      //         is_disable: false
      //       },
      //       bind_operate: {
      //         title: '编外组合绑定业绩',
      //         key: 4,
      //         key_str: '',
      //         value: '',
      //         is_disable: false
      //       },
      //       operate_sales: {
      //         title: '运营专属销售业绩',
      //         key: 5,
      //         key_str: 'operate_sales',
      //         value: '100',
      //         is_disable: true
      //       },
      //       operate_bind: {
      //         title: '运营绑定销售业绩',
      //         key: 6,
      //         key_str: '',
      //         value: '',
      //         is_disable: false
      //       }
      //     }
      //   }
      // ]
      this.list = data2.list
      this.list = this.list.map((v) => {
        if (v.status === 1) {
          v.statusSwitch = 'success'
          v.statusSwitchText = '已生效'
        } else if (v.status === 0) {
          v.statusSwitch = ''
          v.statusSwitchText = '待生效'
        } else if (v.status === 2) {
          v.statusSwitch = 'info'
          v.statusSwitchText = '已过期'
        }
        return { ...v }
      })
      this.loading = false
    },
    async handleDetail (value) {
      this.loading = true
      let id = value.id
      const data = await getOtherSettingDetail(id, { id }).catch(() => {
        this.loading = false
      })
      this.loading = false
      let result = []
      let arr = []
      if (data.exclude_operate_store) {
        arr = data.exclude_operate_store.split(',')
        const res = await getStoreList(this.params)
        arr = arr.map((v) => {
          res.list.map((i) => {
            if (Number(v) === i.store_id) {
              result.push(i.store_name)
            }
          })
        })
      }

      this.proportionProps = data.proportion
      this.proportionProps.excludeOperateStore = result
      this.detailVisible = true
    },
    async handleEdit (value) {
      console.log(value)
      if (value.status === 1 || value.status === 2) {
        this.$message({
          type: 'warning',
          message: '已开始或已结束的规则不能编辑'
        })
      } else {
        this.$router.push({ path: `/customerConversion/performanceDistribution/${value.id || 0}` })
      }
    },
    handleDelete (value) {
      this.$confirm('此操作将删除业绩配比规则，是否继续?', '删除规则', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = true
          let id = value.id
          deleteOtherSetting(id, { id })
            .then((data) => {
              if (data.result) {
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                })
                this.getData()
              }
            })
            .catch(() => {
              this.loading = false
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    async handleSaveDefaultSetting () {
      this.loading = true
      let params = {
        proportion: this.proportion,
        exclude_operate_store:
          (this.excludeOperateStore && this.excludeOperateStore.toString()) || ''
      }
      const data = await saveDefaultSettingList(params).catch(() => {
        this.loading = false
      })
      if (data && data.status === true) {
        this.$message({
          message: '保存成功',
          type: 'success'
        })
      }
      this.getData()
    },
    exclusionVisibleChange (value) {
      if (value[0] === false) {
        this.exclusionVisible = false
      }
      if (value[1]) {
        this.excludeOperateStore = value[1]
      }
    },
    editVisibleChange (value) {
      this.editVisible = false
      this.getData()
      // this.proportionProps = { proportion: this.defaultProportion }
    }
  }
}
</script>

<style lang="scss" scoped>
.top {
  padding-bottom: 14px;
  background: #fff;
  margin-bottom: 20px;
}
.bb {
  border-bottom: 1px solid #e9e9e9;
}
.w45 {
  width: 45%;
}
.w90 {
  width: 90%;
}
.mr10 {
  margin-right: 10px;
}
.red {
  color: red;
}
.search-btn {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 20px;
  li {
    margin-right: 20px;
  }
}

.el-header {
  text-align: bottom;
  line-height: 60px;
}

.el-main {
  text-align: left;
}
.el-row {
  margin-bottom: 10px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-container {
  background-color: #fff;
}
.grid-content {
  min-height: 46px;
  padding: 0 5px;
}
</style>
